class SelectThumbnailSlideshowComponent extends SliderComponent {
  constructor() {
    super();
    console.log('SelectThumbnailSlideshowComponent: Constructor initialized');
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) {
      console.log('SelectThumbnailSlideshowComponent: No slider control wrapper found');
      return;
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    
    this.mainSlideshow = this.querySelector('.slideshow');
    this.thumbnailSlider = this.querySelector('.slideshow__thumbnails');
    this.thumbnailDots = this.querySelectorAll('.slideshow__thumbnail-dot');
    this.thumbnails = this.thumbnailSlider ? Array.from(this.thumbnailSlider.children) : [];
    this.closeButton = this.querySelector('.slideshow-close');
    this.sliderArrows = this.querySelector('.slider-buttons__arrows');
    
    console.log('SelectThumbnailSlideshowComponent: Thumbnail dots count:', this.thumbnailDots.length);
    console.log('SelectThumbnailSlideshowComponent: Thumbnail slider found:', !!this.thumbnailSlider);

    if (this.thumbnailSlider) {
      this.thumbnailSlider.addEventListener('click', this.handleThumbnailClick.bind(this));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
    }

    

    if (this.thumbnailDots && this.thumbnailDots.length > 0) {
      this.thumbnailDots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.setThumbnailSliderPosition(index));
      });
    } else {
      console.log('SelectThumbnailSlideshowComponent: No thumbnail dots found');
      this.thumbnailDots = null;
    }

    this.currentThumbnailIndex = 0;
    this.scrollTimeout = null;

    if (this.thumbnailSlider) {
      this.thumbnailSlider.addEventListener('scroll', this.debouncedHandleThumbnailScroll.bind(this));
    }

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    
    this.updateThumbnailDots(0);
    console.log('SelectThumbnailSlideshowComponent: Constructor completed');
  }

  setAutoPlay() {
    console.log('SelectThumbnailSlideshowComponent: Setting up autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    console.log('SelectThumbnailSlideshowComponent: Button clicked:', event.currentTarget.name);
    super.onButtonClick(event);
    this.wasClicked = true;
  
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
  
    this.setSlidePosition(this.slideScrollPosition);
  
    // Add a flag to determine if the action is from the main slider navigation
    if (!event.target.closest('.slideshow__thumbnails')) {
      // Only update dots if not from main slider arrow navigation
      console.log('SelectThumbnailSlideshowComponent: Arrow navigation, skipping dot update');
      return;
    }
  
    this.updateThumbnailDots(this.currentPage - 1);
  }

  setSlidePosition(position) {
    console.log('SelectThumbnailSlideshowComponent: Setting slide position:', position);
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  debouncedHandleThumbnailScroll() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.handleThumbnailScroll();
    }, 50); // 50ms debounce
  }

  handleThumbnailScroll() {
    const newIndex = this.getCurrentThumbnailIndex();
    if (newIndex !== this.currentThumbnailIndex) {
      this.currentThumbnailIndex = newIndex;
      this.updateThumbnailDots(this.currentThumbnailIndex);
      console.log('SelectThumbnailSlideshowComponent: Scroll updated index to', this.currentThumbnailIndex);
    }
  }

  getCurrentThumbnailIndex() {
    if (!this.thumbnailSlider || this.thumbnails.length === 0) return 0;

    const scrollLeft = this.thumbnailSlider.scrollLeft;
    const thumbnailWidth = this.thumbnails[0].offsetWidth;
    return Math.round(scrollLeft / thumbnailWidth);
  }

  setThumbnailSliderPosition(index) {
    console.log('SelectThumbnailSlideshowComponent: Setting thumbnail slider position:', index);
    
    if (!this.thumbnailSlider || this.thumbnails.length === 0) {
      console.log('SelectThumbnailSlideshowComponent: No thumbnail slider or thumbnails found');
      return;
    }

    if (!this.thumbnailDots || this.thumbnailDots.length === 0) {
      console.log('SelectThumbnailSlideshowComponent: No thumbnail dots found');
      return;
    }

    const thumbnailWidth = this.thumbnails[0].offsetWidth;
    if (!thumbnailWidth) {
      console.log('SelectThumbnailSlideshowComponent: Thumbnail width is 0 or not available');
      return;
    }

    console.log('SelectThumbnailSlideshowComponent: Thumbnail width:', thumbnailWidth);
    
    // Update thumbnail slider
    const thumbnailScrollPosition = thumbnailWidth * index;
    this.thumbnailSlider.scrollTo({
      left: thumbnailScrollPosition,
      behavior: 'smooth'
    });
  
    this.currentThumbnailIndex = index;
    this.updateThumbnailDots(index);
    this.showMainSlideshow(index);
  }

  updateThumbnailDots(activeIndex) {
    console.log('SelectThumbnailSlideshowComponent: Updating thumbnail dots, active index:', activeIndex);
    if (this.thumbnailDots && this.thumbnailDots.length > 0) {
      this.thumbnailDots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('slider-counter__link--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('slider-counter__link--active');
          dot.removeAttribute('aria-current');
        }
      });
    } else {
      console.log('SelectThumbnailSlideshowComponent: No thumbnail dots to update');
    }
  }


  update() {
    console.log('SelectThumbnailSlideshowComponent: Updating');
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
  
    if (!this.sliderControlButtons.length) return;
  
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
  
    if (this.currentPage > 0 && this.currentPage <= this.sliderControlButtons.length) {
      const activeButton = this.sliderControlButtons[this.currentPage - 1];
      if (activeButton) {
        activeButton.classList.add('slider-counter__link--active');
        activeButton.setAttribute('aria-current', true);
      }
    }
    
    this.updateThumbnailDots(this.currentPage - 1);
  }

  autoPlayToggle() {
    console.log('SelectThumbnailSlideshowComponent: Toggling autoplay');
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    console.log('SelectThumbnailSlideshowComponent: Focus out event');
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    console.log('SelectThumbnailSlideshowComponent: Focus in event');
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider && this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    console.log('SelectThumbnailSlideshowComponent: Playing slideshow');
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    console.log('SelectThumbnailSlideshowComponent: Pausing slideshow');
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    console.log('SelectThumbnailSlideshowComponent: Toggling play button state');
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    console.log('SelectThumbnailSlideshowComponent: Auto-rotating slides');
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);

    this.updateThumbnailDots(this.currentPage % this.thumbnailDots.length);
  }

  setSlideVisibility(event) {
    console.log('SelectThumbnailSlideshowComponent: Setting slide visibility');
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
        this.updateThumbnailDots(index);
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  linkToSlide(event) {
    console.log('SelectThumbnailSlideshowComponent: Linking to slide');
    event.preventDefault();
    const index = this.sliderControlLinksArray.indexOf(event.currentTarget);
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (index + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
    this.setThumbnailSliderPosition(index);
  }

  handleThumbnailClick(event) {
    const clickedThumbnail = event.target.closest('.slideshow__thumbnail');
    if (clickedThumbnail) {
      const index = Array.from(this.thumbnailSlider.children).indexOf(clickedThumbnail);
      this.showMainSlideshow(index);
    }
  }

  handleCloseClick() {
    this.hideMainSlideshow();
  }

  showMainSlideshow(index) {
    if (this.mainSlideshow) {
      this.sliderArrows.style.display = 'flex';
      this.mainSlideshow.classList.add('show');
      //this.mainSlideshow.style.display = 'flex';
      
      this.setSlidePosition(this.sliderFirstItemNode.clientWidth * index);
      this.updateThumbnailDots(index);
    }
  }

  hideMainSlideshow() {
    if (this.mainSlideshow) {
      this.sliderArrows.style.display = 'none';
      //this.mainSlideshow.style.display = 'none';
      if (this.mainSlideshow.classList.contains('show')) {
        this.mainSlideshow.classList.remove('show');
      }
    }
  }
  
}

console.log('Defining SelectThumbnailSlideshowComponent');
customElements.define('select-thumbnail-slideshow-component', SelectThumbnailSlideshowComponent);
console.log('SelectThumbnailSlideshowComponent defined');